import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Footer sections data
  const footerSections = [{
    title: "Accounts",
    links: [{
      text: "Facebook Accounts",
      href: "/?category=facebook-profiles"
    }, {
      text: "Business Manager",
      href: "/?category=business-manager"
    }, {
      text: "Facebook Fanpage",
      href: "/?category=facebook-fanpage"
    }]
  }, {
    title: "Company",
    links: [{
      text: "Blog",
      href: "/blog"
    }, {
      text: "FAQ",
      href: "/faq"
    }, {
      text: "Contact Us",
      href: "/contact"
    }]
  }, {
    title: "Legal",
    links: [{
      text: "Privacy Policy",
      href: "/privacy"
    }, {
      text: "Terms of Service",
      href: "/terms"
    }, {
      text: "Refund Policy",
      href: "/refund"
    }]
  }, {
    title: "Support",
    links: [{
      text: "Help Center",
      href: "/faq"
    }, {
      text: "Contact Us",
      href: "/contact"
    }]
  }];

  // Placeholder SVG for Telegram, you can replace it with a more accurate one if needed
  const TelegramIcon = () => <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zM18 7.4c-.133.593-1.48 6.44-1.84 8.038-.34 1.522-.863 1.586-1.22.192-.72-2.822-1.42-4.65-2.182-6.42-.18-.42-.36-.84.18-1.14.54-.3.9-.24.9-.24s.36.06.42.3c.06.24.12.48.12.6 0 .06-.12.3-.18.36-.06.06-.12.12-.12.12s-.06.06 0 .12c.06.06.12.12.24.18.12.06.42.24.84.48.42.24.72.36.9.42.18.06.36.12.48.18.12.06.24.06.36-.06.12-.12.12-.24.12-.42s0-.36-.06-.42c-.06-.06-.12-.12-.3-.18-.18-.06-.42-.12-.42-.12s-.36-.12-.54-.3c-.18-.18-.3-.36-.24-.54.06-.18.12-.42.18-.54.36-1.023 1.14-3.488 1.2-3.548.06-.06.12-.06.12-.06s.12 0 .18.06c.06.06.06.12.06.18z" />
    </svg>;
  const FacebookIcon = () => <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
    </svg>;
  return <footer className="w-full border-t border-border mt-auto bg-card">
      <div className="container mx-auto w-full py-8 lg:py-12 px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-5">
          {/* Column 1: Logo & Social Media */}
          <div className="col-span-2 md:col-span-3 lg:col-span-1 mb-8 lg:mb-0">
            <Link to="/" className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-primary via-blue-600 to-purple-600 bg-clip-text text-transparent">
              AccZen.net
            </Link>
            <p className="text-muted-foreground text-sm mt-4 mb-6">
              The leading platform for all your secure and reliable digital account needs.
            </p>
            
          </div>

          {/* Dynamic Footer Sections */}
          {footerSections.map((section, index) => <div key={index}>
              <h2 className="mb-6 text-sm font-semibold text-foreground uppercase">{section.title}</h2>
              <ul className="text-muted-foreground font-medium space-y-4 text-sm">
                {section.links.map((link, linkIndex) => <li key={linkIndex}>
                    <Link to={link.href} className="hover:underline">{link.text}</Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <hr className="my-6 border-border sm:mx-auto lg:my-8" />
        <div className="text-center">
          <span className="text-sm text-muted-foreground">
            © {currentYear} AccZen.net™. All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>;
};
export default Footer;
